import { render, staticRenderFns } from "./childRank.vue?vue&type=template&id=ca049cd4&scoped=true&"
import script from "./childRank.vue?vue&type=script&lang=js&"
export * from "./childRank.vue?vue&type=script&lang=js&"
import style0 from "./childRank.vue?vue&type=style&index=0&id=ca049cd4&prod&lang=scss&"
import style1 from "./childRank.vue?vue&type=style&index=1&id=ca049cd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca049cd4",
  null
  
)

export default component.exports